exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".users-list>li img{\r\n    max-width:100%;\r\n    border-radius: unset !important;\r\n    height: 300px;    \r\n}\r\n.users-list>li img:hover{\r\n  cursor: pointer;   \r\n}\r\n.label{\r\n    font-size:13px;\r\n}\r\n.empty{\r\n    width: 100%;\r\n    height: 100px;\r\n    margin-top: 3%;\r\n    font-size: 20px;\r\n    color: darkgray;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/playitadmin_frontend/src/app/games/games.component.css
// module id = ../../../../../src/app/games/games.component.css
// module chunks = main